import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useStoreSelector } from "../../../../../hooks/StoreHooks";
import { Box, Typography, Grid, TextField } from "@mui/material";
import { getCurrentUser } from "../../../../core/common_functions";
import { Allegati } from "../../../../models/allegati";
import { useDoorConfigurationsApi } from "../../../../api/door_configurations_api";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { useConfigurationsServicePergola } from "../../../../services/pergola_service";

export const RilievoRecapPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { base } = useStoreSelector((store) => store);
  const currentUser = getCurrentUser(base);
  const pergolaService = useConfigurationsServicePergola();
  const [formData, setFormData] = useState({
    referente: "",
    email: "",
    telefono: "",
    note: "",
  });

  const [selectedFiles, setSelectedFiles] = useState<Allegati[]>([]);
  const [loading, setLoading] = useState(true);

  const doorConfigurationsApi = useDoorConfigurationsApi();

  const quoteNumber = id ? Number(id) : null;
  useEffect(() => {
    if (!id || isNaN(Number(id))) {
      navigate("/configurations");
      return;
    }

    const loadData = async () => {
      try {
        const data = await pergolaService.getRilievo(currentUser, Number(id));

        const files: Allegati[] = await doorConfigurationsApi.getAllegati(
          currentUser,
          Number(id)
        );

        setSelectedFiles(files);
        setFormData({
          referente: data.referente || "",
          email: data.email || "",
          telefono: data.telefono || "",
          note: data.notes || "",
        });
      } catch (error) {
        console.error("Errore caricamento dati rilievo:", error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [id, currentUser]);

  const dwAllegati = async (allegatoId: string, fileName: string) => {
    doorConfigurationsApi.downloadAllegato(currentUser, allegatoId, Number(id!), fileName);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center h-full">
        <Typography>Caricamento riepilogo rilievo...</Typography>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-full p-0">
      <div className="col-xl-5 p-0" style={{ overflowY: "auto", height: "90%" }}>
        {/* Dati di contatto - sola lettura */}
        <Box component="div" mt={4}>
          <Typography variant="h6" gutterBottom>
            Dati di contatto
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Referente"
                name="referente"
                value={formData.referente}
                InputProps={{ readOnly: true }}
                variant="filled"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                type="email"
                value={formData.email}
                InputProps={{ readOnly: true }}
                variant="filled"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Telefono"
                name="telefono"
                value={formData.telefono}
                InputProps={{ readOnly: true }}
                variant="filled"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Note"
                name="note"
                multiline
                rows={3}
                value={formData.note}
                InputProps={{ readOnly: true }}
                variant="filled"
              />
            </Grid>
          </Grid>
        </Box>

        {/* Allegati - solo visualizzazione */}
        <Typography variant="h6" gutterBottom mt={4}>
          Allegati Rilievo
        </Typography>

        {selectedFiles.length === 0 ? (
          <Typography color="textSecondary" fontStyle="italic">
            Nessun allegato caricato.
          </Typography>
        ) : (
          <Box component='div'>
            {selectedFiles.map((file) => (
              <div
                key={file.guid}
                className="d-flex align-items-center justify-content-between p-3 border rounded mb-2 bg-light"
              >
                <Typography variant="body2">{file.filename}</Typography>
                <CloudDownloadIcon
                  className="text-primary cursor-pointer hover:opacity-80"
                  onClick={() => dwAllegati(file.guid, file.filename)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            ))}
          </Box>
        )}
      </div>
    </div>
  );
};